export type CachedFunction<T> = {
  (...args: any[]): Promise<T>;
  invalidate: (...args: any[]) => void;
  invalidateAll: () => void;
};

//Creates a cache closure for each function it wraps
//Eached cached function will have its own cache map
export function cache<T>(fn: (...args: any[]) => Promise<T>): CachedFunction<T> {

  if (!fn || typeof fn !== 'function') {
    return fn as any; // Return as-is if not a function
  }

  const cacheMap = new Map<string, Promise<T>>();

  const cachedFn = (...args: any[]): Promise<T> => {
    const key = JSON.stringify(args);

    if (!cacheMap.has(key)) {
      console.log(`Cache MISS for function '${fn.name || 'anonymous'}' with key:`, key);
      cacheMap.set(key, fn(...args));
    }

    return cacheMap.get(key)!;
  };

  //Invalidate specific cache entry
  cachedFn.invalidate = (...args: any[]) => {
    const key = JSON.stringify(args);
    cacheMap.delete(key);
  };

  //Invalidate all cache entries for this function
  cachedFn.invalidateAll = () => {
    console.log(`InvalidateAll '${fn.name || 'anonymous'}'`);
    cacheMap.clear();
  };

  return cachedFn;
}